import React from "react";

import { useLocation } from "react-router-dom";
// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ErrorIntegrationScreen(props) {
  let query = useQuery();
  const error = query.get("error");
  const error_description = query.get("error_description");

  return (
    <div
      id="course-screen"
      className={`${props.className} dashboard-container`}
    >
      <h1> Error on Authorization:  {error} </h1>
      <h4> {error_description} </h4>        
    </div>
  );
}

export default ErrorIntegrationScreen;
